import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';

import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JhiEventManager } from 'ng-jhipster';

import { ILoadingTypeMySuffix } from 'src/app/shared/model/loading-type-my-suffix.model';
import { LoadingTypeMySuffixService } from './loading-type-my-suffix.service';
import { LanguageChangeService } from 'src/app/shared/services/language-change.service';

import { ConfirmationModelService } from 'src/app/shared/confirmation-modal/confirmation-model.service';
import { FutureDataType } from 'src/app/shared/model/future_data_type.model';

@Component({
    selector: 'jhi-loading-type-my-suffix-delete-dialog',
    templateUrl: './loading-type-my-suffix-delete-dialog.component.html'
})
export class LoadingTypeMySuffixDeleteDialogComponent {
    loadingType: ILoadingTypeMySuffix;
    futureStatus: boolean = false;
    isConfirmed: boolean = false;

    constructor(
        private loadingTypeService: LoadingTypeMySuffixService,
        public activeModal: NgbActiveModal,
        private eventManager: JhiEventManager,
        private futureRecordService: ConfirmationModelService
    ) {}

    clear() {
        this.activeModal.dismiss('cancel');
    }

    setFutureStatus(futureStatus) {
        this.futureStatus = futureStatus;
    }

    confirmDelete(id: number) {
        this.isConfirmed = true;
        if (this.futureStatus) {
            this.updateExistedFutureRecordStatus(id);
        }
        this.loadingTypeService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'loadingTypeListModification',
                content: 'Deleted an loadingType'
            });
            this.activeModal.dismiss(true);
        });
    }

    updateExistedFutureRecordStatus(id: number) {
        this.futureRecordService.updateExistedFutureRecordStatus({
            masterId: this.loadingType.id,
            futureDataType: FutureDataType.LOADING_TYPE.valueOf(),
            fromEffectiveDateFormatted: this.loadingType.fromEffectiveDate,
            masterStatus : this.loadingType.activeStatus == 'ACTIVE' ? 'IN_ACTIVE' : 'ACTIVE',
        }).subscribe(response => {
            console.log(response.body);
        });
    }
}

@Component({
    selector: 'jhi-loading-type-my-suffix-delete-popup',
    template: ''
})
export class LoadingTypeMySuffixDeletePopupComponent implements OnInit, OnDestroy {
    private ngbModalRef: NgbModalRef;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private modalService: NgbModal,
        private languageChangeService: LanguageChangeService
    ) {
        this.languageChangeService.refreshLanguage();
         this.activatedRoute.queryParamMap.subscribe((paramMap: ParamMap) => {
            const refresh = paramMap.get('refresh');
            if (refresh) {
                 
                this.languageChangeService.refreshLanguage();
            }
    });
    }

    ngOnInit() {
        this.activatedRoute.data.subscribe(({ loadingType }) => {
            setTimeout(() => {
                this.ngbModalRef = this.modalService.open(LoadingTypeMySuffixDeleteDialogComponent as Component, {
                    size: 'lg',
                    backdrop: 'static'
                });
                this.ngbModalRef.componentInstance.loadingType = loadingType;
                this.ngbModalRef.result.then(
                    result => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/loading-type']));
                        this.ngbModalRef = null;
                    },
                    reason => {
                        //this.router.navigate([{ outlets: { popup: null } }], { replaceUrl: true, queryParamsHandling: 'merge' });
                        this.router.navigateByUrl('', { skipLocationChange: true }).then(() => this.router.navigate(['/data-management/loading-type']));
                        this.ngbModalRef = null;
                    }
                );
            }, 0);
        });
        
       
    }

    ngOnDestroy() {
        this.ngbModalRef = null;
    }
}
